<script context='module'>
  import { getContext } from 'svelte';

  export const CONTEXT_KEY = Symbol('CurrentOrganizationProvider.CONTEXT_KEY');
  export const useCurrentOrganization = () => getContext(CONTEXT_KEY);
</script>

<script>
  import { derived } from 'svelte/store';
  import { path } from 'ramda';
  import Provider from '@commercebear/components/Provider';
  import { getStores } from '$app/stores';

  const { page } = getStores();

  // Though the current organization is a store, and will update reactively with changes
  // from `$session`, we should NOT be modifying the organization (or user/token) of the
  // session while the page loads, as this just adds unnecessary complication.
  //
  // When the organization changes, the browser will fully reload, so we have no risk of
  // keeping information from the wrong organization around. Pages don't really need to
  // continue to be reactive based on `$currentOrganization`, just do whatever is convenient.
  const currentOrganization = derived(page, path(['data', 'session', 'organization']));
</script>

<Provider key={CONTEXT_KEY} value={currentOrganization}>
  <slot />
</Provider>
